const cardColorClass = {
    0: 'color3',
    1: 'color1',
    2: 'color2',
    3: 'color3',
};

export { cardColorClass };
